import { Button, GridRow, OverflowText } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { FinishButton } from "../button/ValidationButton";
import WizardStore from "./WizardStore";

interface PPWizardActionProps {
	/** store to which this component reacts */
	store: WizardStore;
}

const WizardActions: FunctionComponent<PPWizardActionProps> = observer((props) => {
	const { store } = props;

	const {
		index,
		pageSize,
		previousPage,
		nextPage,
		cancel,
		finish,
		actionMessage,
		validateOnSave,
		disablePrimaryButton,
		disableFinishButton,
		showFinishButton,
	} = store;

	return (
		<GridRow 
			alignItems="center"
			flexWrap="nowrap"
			growChild={index === 0 ? 0 : 1}
			spacing={2}
			textAlign="left"
		>
			{index != 0 && (
				<Button
					design="secondary"
					onClick={(event) => previousPage()}
					res="Back"
				/>
			)}
			<OverflowText text={actionMessage} />
			{index != (pageSize - 1) && (
				<Button
					design="primary"
					disabled = {disablePrimaryButton}
					onClick={nextPage}
					res="Next"
				/>
			)}
			{showFinishButton && (
				<FinishButton
					disabled={disableFinishButton}
					onAction={finish}
					onValidate={validateOnSave}
				/>
			)}
			<Button
				design="link"
				onClick={cancel}
				res="Cancel"
			/>
		</GridRow>
	);
});

export default WizardActions;